import React, {Component} from 'react';
import DefaultModal from "../invoice/DefaultModal";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../local_node_modules/react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import NumberFormat from "react-number-format";
import {Decimal} from "decimal.js";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import moment from "moment";
import ReactLoading from "react-loading";
import axios from "axios";
import {isValidERPOutboxPyld} from "../../common/componentValidation";
import {modifyDespatch, modifyInvoice} from "./erpHelper";

class GetFromConnectorModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
			selectedList:[],
			outboxList:[],
			randomColorList:[],
			searchQuery:undefined,
			index:0,
			totalLength:null,
			loopSize:null,
			savedIndex:0
		};
		this.onCancel     	 = this.onCancel.bind(this);
		this.onChange    	 = this.onChange.bind(this);
		this.getStatusRender = this.getStatusRender.bind(this);
	}

	getStatusRender(status) {
		let className =(status === "processing" ? "spinner fa-spin" : (status==="success" ? "check" :(status==="error" ? "close":"pause")));
		let color= (status === "processing" ? "dark" : (status==="success" ? "green" :(status==="error" ? "red":"dark")));
		return (<i className={"fas fa-" + className} style={{color:color,paddingRight:"4px"}}></i>);
	}

	onChange(e,index){
		let outboxList = deepCopyObject(this.state.outboxList);
		outboxList[index][e.name]=
			((e.name === "invoiceQuantity" && e.value !== "" ) ||
				(e.name === "unitPrice"  && e.value !== "") ||
				(e.name === "allowancePercent"  && e.value !== "") ||
				(e.name === "allowanceAmount"  && e.value !== "") ||
				(e.name === "kdvPercent"  && e.value !== "") ||
				(e.name === "kdvAmount"  && e.value !== "") ||
				(e.name === "lineExtensionAmount"  && e.value !== "")) ? (new Decimal(e.value)).toNumber() : e.value;
		this.setState({outboxList});
	}

	outboxFinal = () =>{
		let {outboxList} = this.state
		outboxList = deepCopyObject(outboxList);
		return(outboxList);
	}

	confirm = async () => {
		let self= this;
		let {type}=self.props;
		let {loopSize,savedIndex} = self.state
		this._source = axios.CancelToken.source();

		let loopIndex = 0
		for(loopIndex;loopIndex<loopSize;loopIndex++) {
			let outboxList = self.outboxFinal();

			for(let index = 0;index < outboxList.length;index++){
				let outbox = (type === "despatch" ? modifyDespatch(outboxList[index]) : modifyInvoice(outboxList[index]));
				let result = isValidERPOutboxPyld(outbox, index);
				let valid = result.valid;
				if (valid) {
					let params = {
						url: `/connector/save${(type === 'despatch' ? 'Despatch' : 'Invoice')}ToTemp/`,
						method: 'post',
						cancelToken: self._source.token,
						data: deepCopyObject(outbox)
					};
					outbox.status = "processing";
					outboxList[index] = outbox;
					self.setState({confirmBtnDisabled: true, outboxList});
					try{
						const response = await request(params);
						savedIndex++;
						outbox.profileId = response.data;
						outbox.status = "success";
						outbox.success = true;
						outboxList[index] = outbox;
						self.setState({outboxList,savedIndex});
					}catch (error){
						outbox.status = "error";
						outboxList[index] = outbox;
						self.setState({outboxList, confirmBtnDisabled: false});
						showAxiosError(error, "bottom-right");
						return;
					}
				}else{
					self.setState({error:result.error,confirmBtnDisabled:false});
					Alert.error(result.errorMessage, {
						position: 'bottom-right',
						effect: 'stackslide',
						timeout: 3000,
					html:false
				});}
			}
			if(loopIndex+1!=loopSize ){
				await self.handleSearch();
			}
		}
		Alert.warning('Tüm dokümanlar gönderildi.', {
			position: 'bottom-right',
			effect: 'stackslide',
			timeout: 5000,
				html:false
		});
	}

	documentInformation = async (searchQuery)=> {
		let self = this;
		self.setState({searchQuery});
		let {totalLength,limit,loopSize} = self.state;
		let params = {
			url: `/connector/documentInformation/${self.props.type}/&${searchQuery}`,
			method: "post"
		};
		try{
			let {data} = await request(params);
			limit = data.limit ? data.limit:50;
			totalLength = data.totalLength;
			loopSize= Math.ceil(totalLength/limit);

			self.setState({totalLength, limit, loopSize, savedIndex:0});
			await self.handleSearch();

		}catch(error){
			let err = {response:{data:"Bağlantı Hatası"}}
			showAxiosError(err);
			self.setState({outboxList:[],searching:false});
		}
	}

	handleSearch = async ()=> {
		let self = this;
		let {limit,searchQuery} = this.state;
		let params = {
			url: `/connector/readDocument/${self.props.type}/&${searchQuery}/${limit}`,
			method: "post"
		};
		self.setState({searching: true});
		try{
			let {data} = await request(params);
			if(data.length===0){
				Alert.success("Ara kriterlerine uygun fatura bulunamadı.", {
					position: 'bottom-right',
					effect: 'stackslide',
					timeout: 4000,
					html:false
				});
			}
			self.setState({outboxList:data,searching:false,index:0});
		}catch(error){
			let err = {response:{data:"Bağlantı Hatası"}}
			showAxiosError(err);
			self.setState({outboxList:[],searching:false});
		}
	}

	onCancel(){
		if(this._source)
			this._source.cancel();

		if(this.state.index > 0){
			this.props.toggleModal(false,true);
		}else{
			this.props.toggleModal(false,false);
		}
	}

	render() {

		let {type} = this.props;
		let {outboxList} = this.state;
		const fields = [
			{
				label: `${type==="invoice" ? "Fatura" : type === "sigorta"? "Sigorta" :"İrsaliye"} Numarası`,
				accessor: "documentId",
				type: "text",
				operator: "=",
			},
			{
				label: `${type==="invoice" ? "Fatura" :type === "sigorta"? "Sigorta"  : "İrsaliye"} Tarihi (Başlangıç)`,
				accessor: "minIssueDate",
				type: "date",
				operator: "=",
				initialValue: moment().subtract('days', 7).format('YYYY-MM-DD'),
				disableAccessibleDate: true
			},
			{
				label:  `${type==="invoice" ? "Fatura" :type === "sigorta"? "Sigorta" : "İrsaliye"} Tarihi (Bitiş)`,
				accessor: "maxIssueDate",
				type: "date",
				operator: "=",
				initialValue: moment().format('YYYY-MM-DD'),
				disableAccessibleDate: true
			}
		];

		return (
			<DefaultModal disabled={this.state.searching || this.state.confirmBtnDisabled || (this.state.outboxList && this.state.outboxList.length ===0)}
						  isOpen={this.props.modal}
                          size="xxl"
						  title={this.props.title || ""}
						  confirmBtnText="Taslağa Kaydet"
						  cancelBtnText="Kapat"
						  onConfirm={()=>this.confirm()}
						  onCancel={this.onCancel}
			>
				<div className="row satirBasi" style={{marginTop: 20}}>
					<div className="col-sm-12" style={{zIndex:9999,padding: '1',maxHeight:'450px'}}>
						<DetailedSearch fields={fields}
										loading={this.state.searching}
										onSearch={this.documentInformation}/>
					</div>
					<div className="col-sm-12" style={{paddingBottom: '20px',maxHeight:'500px', overflow:"auto"}}>
						{this.state.searching &&
							<ReactLoading type="spinningBubbles" style={{
								width: "70px",
								height: "70px",
								margin: "20px auto 0 auto",
								fill: "#888"
							}}/>
						}
						{!this.state.searching && outboxList.length>0 &&
							<table className="" style={{textAlign: 'center'}}>
								<thead>
								<tr style={{backgroundColor: '#ebedf0'}}>
									<th width="8%">{`${type==="invoice" ? "Fatura" : "İrsaliye"} No`}</th>
									<th width="12%">{`${type==="invoice" ? "Fatura" : "İrsaliye"} ETTN`}</th>
									<th width="8%">{`${type==="invoice" ? "Fatura" : "İrsaliye"} Tarihi`}</th>
									<th width="8%">VKN/TCKN</th>
									<th width="22%">Unvan</th>
									<th width="8%">İl</th>
									<th width="9%">Vergiler Hariç Tutar</th>
									<th width="9%">Ödenecek Tutar</th>
									<th width="10%">{`${type==="invoice" ? "Fatura" : "İrsaliye"} Tipi`}</th>
									{/*<th width="6%">İşlemler</th>*/}
								</tr>
								</thead>
								<tbody>
								{this.state.outboxList.map((outbox, index) =>
										<tr key={index}>
											<td style={{fontWeight:'bold', fontSize:'12px', padding: "0px", margin: "0px", backgroundColor: "inherit"}}>
												<input
													id={'documentId_' + index }
													type="text"
													maxLength={16}
													className="form-control"
													value={outbox.documentId}
													disabled={this.state.confirmBtnDisabled || outbox.success}
													onChange={(e) => this.onChange({
														value: e.target.value,
														name: "documentId"
													}, index)}/>
											</td>
											<td>
												<input
													id={'documentUuid_' + index }
													type="text"
													maxLength={255}
													className="form-control"
													value={outbox.documentUuid}
													disabled={true}
													onChange={(e) => this.onChange({
														value: e.target.value,
														name: "documentUuid"
													}, index)}/>
											</td>
											<td>
												{moment(outbox.issueDate).isValid() ? moment(outbox.issueDate).format("DD-MM-YYYY") : ''}
											</td>
											<td>
												<input
													id={'vknTckn_' + index }
													type="text"
													data-vlength="1,255"
													maxLength={255}
													disabled={this.state.confirmBtnDisabled || outbox.success}
													className="form-control"
													value={outbox.vknTckn}
													onChange={(e) => this.onChange({
														value: e.target.value,
														name: "vknTckn"
													}, index)}/>
											</td>
											<td>
												<input
													id={'title_' + index }
													type="text"
													data-vlength="1,255"
													maxLength={255}
													className="form-control"
													value={outbox.title}
													disabled={true}
													onChange={(e) => this.onChange({
														value: e.target.value,
														name: "title"
													}, index)}/>
											</td>
											<td>
												<input
													id={'city_' + index }
													type="text"
													data-vlength="1,255"
													maxLength={255}
													className="form-control"
													value={outbox.city}
													disabled={true}
													onChange={(e) => this.onChange({
														value: e.target.value,
														name: "city"
													}, index)}/>
											</td>
											<td>
												<NumberFormat id={'taxExclusiveAmount_' + index }
															  value={outbox.taxExclusiveAmount}
															  allowNegative={false}
															  isNumericString={true}
															  allowEmptyFormatting={false}
															  decimalScale={9}
															  thousandSeparator={'.'}
															  decimalSeparator={','}
															  displayType="input"
															  placeholder=""
															  disabled={true}
															  renderText={value => {
																  value.replace(/\./g, ',')
															  }}
															  onValueChange={(e) => this.onChange({
																  value: e.value,
																  name: "taxExclusiveAmount"
															  }, index)}
															  className="form-control"/>
											</td>
											<td>
												<NumberFormat id={'payableAmount_' + index }
															  value={outbox.payableAmount}
															  allowNegative={false}
															  isNumericString={true}
															  allowEmptyFormatting={false}
															  decimalScale={9}
															  thousandSeparator={'.'}
															  decimalSeparator={','}
															  displayType="input"
															  placeholder=""
															  disabled={true}
															  renderText={value => {
																  value.replace(/\./g, ',')
															  }}
															  onValueChange={(e) => this.onChange({
																  value: e.value,
																  name: "payableAmount"
															  }, index)}
															  className="form-control"/>
											</td>
											<td>
												<div style={{display:'inline'}}>
													{outbox.documentType || this.getStatusRender(outbox.status)} {outbox.profileId}
												</div>

											</td>
										</tr>
									)}
								</tbody>
							</table>
						}
					</div>
					<div className="col-sm-12" style={{display:"flex", justifyContent:"flex-end"}}>
						<div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Taslağa Aktarılan Kayıt Sayısı: {this.state.outboxList ? this.state.savedIndex : 0}</div>
						<div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Gösterilen Kayıt Sayısı: {this.state.outboxList ? this.state.outboxList.length : 0}</div>
						<div style={{margin:0, marginRight:'10px', fontWeight:'bold'}}>Toplam Kayıt Sayısı: {this.state.totalLength ? this.state.totalLength : 0}</div>
					</div>
				</div>
			</DefaultModal>
		)
	}
}

export default GetFromConnectorModal;